
import {
    Button,
    Grid,
    Paper,
    TextField,
    Box,
    Typography,
    CircularProgress,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { enetremailv1 } from './api';
import { decodeJWT, getToken } from '../../utils/utils';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [apiError, setApiError] = useState('');

     const { emailid } = useParams();
   const token = getToken();
    const navigate = useNavigate();
         const decodedToken = decodeJWT(token);
         console.log(decodedToken, "Decoded token");
               const mainemail = decodedToken?.email;
   
   
    //    const [email, setEmail] = useState(mainemail ?? '');
   
   
      
    const validateEmail = (value: string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        return regex.test(value);
    };
  

    const isError = isSubmitted && !validateEmail(email);
const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        setIsSuccess(false); // Reset success on change
    };

const handleSubmit = async () => {
  try {
    const response = await enetremailv1({ email }, token);
    console.log(response, "eeeeeeeeeee");

    setIsSubmitted(true);

    if (validateEmail(email)) {
      console.log("Reset link sent to:", email);
      setIsSuccess(true);
    //   navigate(`/reset-link`);
    } else {
      setIsSuccess(false);
    }

  } catch (error) {
    console.error("Error sending reset link:", error);
    setIsSuccess(false);
  }
};

    return (
        <Grid container component="main" sx={{ height: '100vh' }}>
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <Box
                    sx={{
                        my: 8,
                        mx: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <img src="/logo-pmi.png" alt="logo" />

                    <Box sx={{ mt: 8, textAlign: 'left', width: '440px' }}>
                        <Typography
                            variant="h5"
                            fontWeight="bold"
                            fontSize="30px"
                            color="#1976D2"
                            gutterBottom
                        >
                            Forgot Password
                        </Typography>
                        <Typography
                            variant="body1"
                            mb={3}
                            fontSize="16px"
                            color="#282829"
                            fontWeight="500"
                        >
                            Enter your Username to receive the password reset link
                        </Typography>

                        <Typography variant="subtitle1" mb={1}>
                            Email Address<span style={{ color: 'red' }}>*</span>
                        </Typography>

                        <TextField
                            fullWidth
                            placeholder="eg. xyz@gmail.com"
                            variant="outlined"
                            value={email}
                            onChange={handleChange}
                            error={isError || !!apiError}
                            helperText={
                                isError ? (
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <InfoOutlinedIcon sx={{ color: '#E63946', fontSize: 18 }} />
                                        <span>Enter correct Email ID</span>
                                    </Box>
                                ) : apiError ? (
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <InfoOutlinedIcon sx={{ color: '#E63946', fontSize: 18 }} />
                                        <span>{apiError}</span>
                                    </Box>
                                ) : isSuccess ? (
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <CheckCircleOutlineIcon sx={{ color: '#2ECC71', fontSize: 18 }} />
                                        <Typography sx={{ color: 'green', fontSize: 13 }}>
                                            Password reset link sent successfully!
                                        </Typography>
                                    </Box>
                                ) : (
                                    ''
                                )
                            }
                            sx={{
                                mb: 1,
                                fontSize: '16',
                                border: 'none',
                                '& .MuiOutlinedInput-root': {
                                    backgroundColor: isError || apiError
                                        ? '#FFECEC'
                                        : isSuccess
                                        ? '#E6FAEA'
                                        : '#F9FBFC',
                                    borderundaius: '10px',
                                    '& fieldset': {
                                        border: 'none',
                                        borderBottom:
                                            isError || apiError
                                                ? '1px solid #E63946'
                                                : isSuccess
                                                ? '1px solid #2ECC71'
                                                : 'none',
                                    },
                                    '&:hover fieldset': {
                                        border:
                                            isError || apiError
                                                ? '1px solid #E63946'
                                                : isSuccess
                                                ? '1px solid #2ECC71'
                                                : 'none',
                                    },
                                    '&.Mui-focused fieldset': {
                                        border:
                                            isError || apiError
                                                ? '1px solid #E63946'
                                                : isSuccess
                                                ? '1px solid #2ECC71'
                                                : 'none',
                                    },
                                },
                                '& .MuiFormHelperText-root': {
                                    color: isError || apiError ? '#E63946' : isSuccess ? '#2ECC71' : '',
                                    fontSize: '13px',
                                    marginLeft: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                },
                            }}
                        />

                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={!email || isLoading}
                            sx={{
                                backgroundColor: !email || isLoading ? '#A9A9A9' : '#C8172F',
                                color: 'white',
                                textTransform: 'none',
                                borderRadius: 2,
                                py: 1.5,
                                boxShadow: 0,
                                fontSize: '14px',
                                lineHeight: 1.15,
                                mt: 2,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                            }}
                        >
                            {isLoading ? (
                                <>
                                    <CircularProgress size={20} color="inherit" />
                                    Sending...
                                </>
                            ) : (
                                'Send Reset Link'
                            )}
                        </Button>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default ForgotPassword;
